export const CHAT_REQUEST_LIST = 'CHAT_REQUEST_LIST'; 
export const SELECTED_CHAT_RQUEST = 'SELECTED_CHAT_RQUEST'; 
export const CHAT_DATA_LIST = 'CHAT_DATA_LIST'; 
export const SELECTED_CHATID = 'SELECTED_CHATID'; 